"use strict";
exports.__esModule = true;
exports.toPublication = exports.PUBLICATION_TYPE_PRISMIC_TO_LGLP = void 0;
var types_1 = require("../../types");
exports.PUBLICATION_TYPE_PRISMIC_TO_LGLP = {
    'Résultats annuels': types_1.FinancialPublication.FullYearResult,
    'Résultats semestriels': types_1.FinancialPublication.HalfResult,
    'Présentations investisseurs': types_1.FinancialPublication.InvestorPresentations,
    'Documents de référence': types_1.FinancialPublication.ReferenceDocument,
    'Green Bond': types_1.FinancialPublication.GreendBond,
    'Rapports RSE': types_1.FinancialPublication.RseReport,
    'Document d’enregistrement universel': types_1.FinancialPublication.Urd,
    "Rapports sur le gouvernement d'entreprise": types_1.FinancialPublication.EnterpriseGovernmentReport,
    "Droits de vote et nombre d'actions": types_1.FinancialPublication.VotingRightNbActions
};
var toPublication = function (prismicPublication, logger) {
    return logger.toConstValue(prismicPublication, exports.PUBLICATION_TYPE_PRISMIC_TO_LGLP);
};
exports.toPublication = toPublication;
// export const toPublicationPrismic = prop(
//   __,
//   invertObj(PRISMIC_TO_TYPE_PUBLICATION)
// );
//# sourceMappingURL=publication.js.map